import {DataViewWarning} from 'analysis-tool/data-view/DataViewContext';

export interface DataFrameWarningOptions {
  renderedColumns: number;
  renderedRows: number;
  totalColumns: number;
  totalRows: number;
}

/**
 * Return the warning to display to the user about the data frame.
 */
export default function getDataFrameWarning({
  renderedColumns,
  renderedRows,
  totalColumns,
  totalRows,
}: DataFrameWarningOptions): DataViewWarning | null {
  const labelParts: Array<string> = [];

  if (renderedRows < totalRows) {
    labelParts.push(`${totalRows - renderedRows} rows hidden`);
  }
  if (renderedColumns < totalColumns) {
    labelParts.push(`${totalColumns - renderedColumns} columns hidden`);
  }

  if (labelParts.length === 0) {
    return null;
  }

  return {label: labelParts.join(', '), hoverMessage: 'Download to view the full dataset'};
}
